interface UserTagUse {
  modifiedAt: number
  userTags: readonly string[]
}

/** Orders user-created tags by their newest note use, with current-session uses first. */
export function tagsByMostRecentUse(
  notes: readonly UserTagUse[],
  currentSessionTags: readonly string[] = [],
): string[] {
  const mostRecentUse = new Map<string, number>()
  for (const note of notes) {
    for (const tag of new Set(note.userTags)) {
      mostRecentUse.set(tag, Math.max(mostRecentUse.get(tag) ?? 0, note.modifiedAt))
    }
  }

  const persistedTags = [...mostRecentUse.keys()].sort((left, right) =>
    (mostRecentUse.get(right) ?? 0) - (mostRecentUse.get(left) ?? 0)
      || left.localeCompare(right),
  )

  return [...new Set([...currentSessionTags, ...persistedTags])]
}
